export enum PropertyStatus {
  Available = 'available',
  Reserved = 'reserved',
  Sold = 'sold',
  ComingSoon = 'coming_soon',
}

export enum PropertyType {
  House = 'house',
  LokalMieszkalny = 'lokal-mieszkalny',
  LokalUslugowy = 'lokal uslugowy',
  Garaz = 'garaz',
  Komorka = 'komorka',
  MiejscePostojowe = 'miejsce-postojowe',
  MiejscePodWiata = 'miejsce-pod-wiata',
  BoksGarazowy = 'boks-garazowy',
  NiezadaszoneMiejsceWylacznegoKorzystania = 'niezadaszone-miejsce-wylacznego-korzystania',
}

const RESIDENTIAL: Record<PropertyType, boolean> = {
  [PropertyType.House]: true,
  [PropertyType.LokalMieszkalny]: true,
  [PropertyType.LokalUslugowy]: false,
  [PropertyType.Garaz]: false,
  [PropertyType.Komorka]: false,
  [PropertyType.MiejscePostojowe]: false,
  [PropertyType.MiejscePodWiata]: false,
  [PropertyType.BoksGarazowy]: false,
  [PropertyType.NiezadaszoneMiejsceWylacznegoKorzystania]: false,
};

const GOV_REPORTABLE: Record<PropertyType, boolean> = {
  [PropertyType.House]: true,
  [PropertyType.LokalMieszkalny]: true,
  [PropertyType.LokalUslugowy]: false,
  [PropertyType.Garaz]: true,
  [PropertyType.Komorka]: true,
  [PropertyType.MiejscePostojowe]: true,
  [PropertyType.MiejscePodWiata]: true,
  [PropertyType.BoksGarazowy]: true,
  [PropertyType.NiezadaszoneMiejsceWylacznegoKorzystania]: true,
};

export class Property {
  readonly type: PropertyType;
  readonly includeInGovReporting: boolean;

  constructor(data: { type: PropertyType; includeInGovReporting: boolean }) {
    this.type = data.type;
    this.includeInGovReporting = data.includeInGovReporting;
  }

  get isResidential(): boolean {
    return RESIDENTIAL[this.type];
  }

  get isReportable(): boolean {
    return this.includeInGovReporting && GOV_REPORTABLE[this.type];
  }
}
